export default "__VITE_ASSET__Chat2NHy__"